import LinearCanonicalNetworks from "./LinearCanonicalNetworks";

export default LinearCanonicalNetworks;
